import React, { useEffect, useState } from "react";
import { baseUrl } from '../shared.js';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  Box,
  Typography,
  TableSortLabel,
  TextField,
  MenuItem
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import moment from "moment";

function OpenRepairs() {
  const [repairs, setRepairs] = useState([]);
  const [open, setOpen] = useState({});
  const [orderBy, setOrderBy] = useState("assetId");
  const [order, setOrder] = useState("asc");

  // Filters
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    const url = baseUrl+'repair/allOpenRepairs/'
    fetch(url, {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken'),
      },
  })
      .then(res => res.json())
      .then(data => setRepairs(data));
  }, []);

  const handleToggle = (customer) => {
    setOpen(prev => ({ ...prev, [customer]: !prev[customer] }));
  };

  // Sorting helpers
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortData = (array) => {
    return [...array].sort((a, b) => {
      if (a[orderBy] < b[orderBy]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[orderBy] > b[orderBy]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
  };

  // Filtering
  const filteredRepairs = repairs.filter(r => {
    const statusMatch = statusFilter ? r.status === statusFilter : true;
    
    return statusMatch;
  });

  // Group by customer after filtering
  const grouped = filteredRepairs.reduce((acc, repair) => {
    if (!acc[repair.customer]) {
      acc[repair.customer] = [];
    }
    acc[repair.customer].push(repair);
    return acc;
  }, {});

  // Unique statuses for filter dropdown
  const allStatuses = [...new Set(repairs.map(r => r.status))];

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>Open Repairs / C&amp;Ds</Typography>

      {/* Filters */}
      <Box sx={{ mb: 2, maxWidth: 280 }}>
        <TextField
          select
          fullWidth
          size="small"
          label="Filter by Status"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          {allStatuses.map((status) => (
            <MenuItem key={status} value={status}>
              {status}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      {/* Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(grouped).map(([customer, customerRepairs]) => (
              <React.Fragment key={customer}>
                {/* Company Row */}
                <TableRow>
                  <TableCell>
                    <IconButton size="small" onClick={() => handleToggle(customer)}>
                      {open[customer] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {customer}
                    </Typography>
                  </TableCell>
                </TableRow>

                {/* Collapsible content */}
                <TableRow>
                  <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={2}>
                    <Collapse in={open[customer]} timeout="auto" unmountOnExit>
                      <Box margin={1}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              {["createdAt", "assetId", "catNo", "item", "status"].map((col) => (
                                <TableCell key={col}>
                                  <TableSortLabel
                                    active={orderBy === col}
                                    direction={orderBy === col ? order : "asc"}
                                    onClick={() => handleSort(col)}
                                  >
                                    {col === "createdAt" && "Created"}
                                    {col === "assetId" && "Asset ID"}
                                    {col === "catNo" && "Cat No"}
                                    {col === "item" && "Item"}
                                    {col === "status" && "Repair Status"}
                                  </TableSortLabel>
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {sortData(customerRepairs).map((r, i) => (
                              <TableRow
                                    key={i}
                                    hover
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => {
                                      const baseUrl = window.location.origin;
                                      window.location.href = `${baseUrl}?catNo=${r.catNo}`;
                                    }}
                              >
                                <TableCell>{r.createdAt ? moment(r.createdAt).format('DD/MM/YYYY') : '—'}</TableCell>
                                <TableCell>{r.assetId}</TableCell>
                                <TableCell>{r.catNo}</TableCell>
                                <TableCell>{r.item}</TableCell>
                                <TableCell>{r.status}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default OpenRepairs;